import { useEffect, useState } from 'react';
import { forkJoin, Subscription } from 'rxjs';
import {
    IRequestsUploadsActionsDetailListDto,
    IDisclosuresActionsDetailsDto,
    IEnquiriesActionsDetailsDto
} from '@vivli/features/dashboard/infrastructure/interface';
import { useCrossConcernsApiContext, useModalApiContext } from '@vivli/core/infrastructure/context';

export const useAwaitingActions = () => {
    const modalService = useModalApiContext();
    const service = useCrossConcernsApiContext();

    const [actionsResult, setActionsResult] = useState<{
        requests?: IRequestsUploadsActionsDetailListDto;
        disclosures?: IDisclosuresActionsDetailsDto;
        enquiries?: IEnquiriesActionsDetailsDto;
    } | null>(null);

    const handleFailure = (err: string) => {
        modalService.error(
            `An error occurred getting actions for the Dashboard. Please try again or contact Vivli support. Message: ${err}`
        );
    };

    useEffect(() => {
        const sub: Subscription = forkJoin({
            requests: service.getRequestUploadActionDetails(),
            disclosures: service.getDisclosureActionDetails(),
            enquiries: service.getEnquiryActionDetails()
        }).subscribe({
            next: (res) => setActionsResult(res),
            error: (err) => {
                handleFailure(err);
            }
        });

        return () => sub.unsubscribe();
    }, []);

    return actionsResult;
};
